module.exports = __webpack_public_path__ + "static/media/notification_old.f4084918.mp3";